const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  multiTab: state => state.app.multiTab,
  token: state => state.user.token,
  avatarId: state => state.user.avatarId,
  nickName: state => state.user.nickName,
  account: state => state.user.account,
  accountId: state => state.user.accountId,
  tenantName: state => state.user.tenantName
}

export default getters
